import useSWR from 'swr';
import { customersAdminApiUrl } from '@/Config/Url';

const useDashboard = () => {
    return useSWR(`${customersAdminApiUrl}/dashboard`);
}

export default {
    useDashboard
}